import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'reactstrap';

import actions from './actions';
import actionsGuiaInterativo from '../../actions';
import { Step } from '../guiaInterativo/constants';
import { Select } from './../../components/Inputs';
import InclusaoCheckin from './InclusaoCheckin';
import {
  isCpfValid,
  isApartamentoValid,
  isFuncaoValid,
  isTelefoneValid
} from './../../utils/validation';

class PresencaContratado extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };

    this.checkin = this.checkin.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  componentDidMount() {
    this.props.actions.onLoadContratantes();
    this.props.actions.onLoadContratados();
  }

  checkin(e) {
    e.preventDefault();

    let { data, contratantes } = this.props.value;
    let { contratante, contratado } = data;

    let contratanteTemp =
      !contratante.id && !contratante.text.length
        ? contratantes.result.find(({ text }) => -1 < text.indexOf('0000 -'))
        : contratante;

    if (contratado.id && contratanteTemp.id) {
      this.props.actions.onCheckin({
        contratante: contratanteTemp,
        contratado
      });
    } else {
      this.setState({
        modal: true
      });
    }
  }

  isValid() {
    let { contratante, contratado } = this.props.value.data;

    let errors = [];
    if (
      !contratante.id &&
      !!contratante.text &&
      !isApartamentoValid(contratante.apartamento)
    ) {
      errors.push('Número do apartamento precisa ser informado');
    }

    if (!contratado.id) {
      if (!isCpfValid(contratado.cpf)) {
        errors.push('CPF inválido');
      }
      if (!isTelefoneValid(contratado.telefone)) {
        errors.push('Telefone inválido');
      }
      if (!isFuncaoValid(contratado.funcao.nome)) {
        errors.push('Função inválida');
      }
    }

    if (errors.length) {
      this.props.actions.onCheckin_invalid(errors);
    }

    return !errors.length;
  }

  handleConfirm(e) {
    e.preventDefault();

    if (this.isValid()) {
      let { data, contratantes, empresas, funcoes } = this.props.value;
      let { contratado, contratante } = data;

      let contratanteTemp =
        !contratante.id && !contratante.text.length
          ? contratantes.result.find(({ text }) => -1 < text.indexOf('0000 -'))
          : contratante;
      let funcao = contratado.funcao.nome;
      let empresa = contratado.empresa.nome;

      this.props.actions
        .onCheckin({
          ...data,
          contratante: contratanteTemp,
          contratado: {
            ...contratado,
            funcao: {
              ...contratado.funcao,
              ...funcoes.result.find(({ nome }) => nome === funcao)
            },
            empresa: {
              ...contratado.empresa,
              ...empresas.result.find(({ nome }) => nome === empresa)
            },
            telefone: contratado.telefone.replace(/\D+/g, ''),
            cpf: contratado.cpf.replace(/\D+/g, ''),
            text:
              contratado.nome +
              (funcao ? ' - ' + funcao : '') +
              (empresa ? ' (' + empresa + ')' : '')
          }
        })
        .then(() => {
          this.toggleModal();
        });
    }
  }

  toggleModal() {
    this.setState(({ modal }) => ({
      modal: !modal
    }));
  }

  handleChange(type, field, sanitize = /[^\d\w áéíóúàâêôãõç]+/gi) {
    let { actions, value } = this.props;
    let recursive = (f, v) => {
      var p = f.pop();
      if (!f.length) {
        return { [p]: v };
      }

      return recursive(f, { [p]: v });
    };

    return e => {
      if (!Array.isArray(field)) {
        field = [field];
      }

      return actions.onChange(type, {
        ...value.data[type],
        ...recursive(
          field,
          e.target.value
            .replace(/^\s+|\s+(?=\s$)/g, '')
            .toUpperCase()
            .replace(sanitize, '')
        )
      });
    };
  }

  render() {
    let { value, actions, actionsGuiaInterativo } = this.props;
    let { data, contratantes, contratados, presencas } = value;

    let { modal } = this.state;

    return (
      <div>
        <form className="fcp-container" onSubmit={this.checkin}>
          <Select
            className="fcp-input-contratante"
            id="lista_contratante"
            label="Contratante"
            maxLength={57}
            value={data.contratante.text}
            disabled={1 === presencas.fetching}
            onRefresh={e => actions.onLoadContratantesIfNeeded()}
            onChange={(e, { newValue, method }) => {
              let capitalizedNewValue = newValue.toUpperCase();

              actions.onChange('contratante', {
                ...data.contratante,
                id: null,
                apartamento: capitalizedNewValue.replace(/\D.*$/, ''),
                nome: capitalizedNewValue.replace(/^\d+\s*-?\s*/, ''),
                ...contratantes.result.find(
                  v => v.text === capitalizedNewValue
                ),
                text: capitalizedNewValue
                  .replace(/^\s+|\s+(?=\s$)/g, '')
                  .replace(
                    /(\S)(.*?)\s*-\s*(\S)(\S*)/,
                    ($0, $1, $2, $3, $4) =>
                      $1.toUpperCase() + $2 + ' - ' + $3.toUpperCase() + $4
                  )
              });
            }}
            onBlur={(e, { highlightedSuggestion }) => {
              if (highlightedSuggestion && highlightedSuggestion.id) {
                actionsGuiaInterativo.abrirGuiaSeNecessario(
                  Step.SELECAO_CONTRATANTE_CONFIRMADA
                );
              }
            }}
            {...contratantes}
          />
          <Select
            className="fcp-input-contratado"
            id="lista_contratados"
            label="Contratado"
            value={data.contratado.text}
            maxLength={156}
            valid={0 < data.contratado.text.length}
            autoFocus
            required
            disabled={1 === presencas.fetching}
            onRefresh={e => actions.onLoadContratadosIfNeeded()}
            onChange={(e, { newValue, method }) => {
              let capitalizedNewValue = newValue.toUpperCase();
              let funcao =
                (capitalizedNewValue.match(/-\s*([^(]+)\s*(?:$|\()/, '') &&
                  RegExp.$1.trim()) ||
                '';
              let empresa =
                (capitalizedNewValue.match(/\((.+)\)/) && RegExp.$1.trim()) ||
                '';

              return actions.onChange('contratado', {
                ...data.contratado,
                id: null,
                nome: capitalizedNewValue.replace(/\s*[-(].*$/, ''),
                funcao: { nome: funcao },
                empresa: { nome: empresa },
                ...contratados.result.find(v => v.text === capitalizedNewValue),
                text: capitalizedNewValue
                  .replace(/^\s+|\s+(?=\s$)/g, '')
                  .replace(/(.*?)\s*-\s*(\S+)/, ($0, $1, $2) => $1 + ' - ' + $2)
                  .replace(/(.*?)\s*\((\S+)/, ($0, $1, $2) => $1 + ' (' + $2)
                //text: capitalizedNewValue.replace(/^\s+|\s+(?=\s$)/g, "").replace(/(\S)(.*?)\s*-\s*(\S)(\S*)/, ($0, $1, $2, $3, $4) => $1.toUpperCase() + $2 + " - " + $3.toUpperCase() + $4)
              });
            }}
            {...contratados}
          >
            {1 !== presencas.fetching && (
              <Button
                className="fcp-button-checkin"
                type="submit"
                color="success"
                disabled={
                  3 > data.contratado.text.length ||
                  (data.contratado.id &&
                    presencas.result.some(
                      p => p.contratado.id === data.contratado.id
                    ))
                }
                title="Acabou de chegar!"
              >
                <span className="fa fa-user-plus" />{' '}
                <span className="d-none d-md-inline-block">
                  Acabou de chegar!
                </span>
              </Button>
            )}
            {1 === presencas.fetching && (
              <Button color="dark" disabled={true} title="Carregando...">
                <span className="fa fa-spinner fa-spin" />{' '}
                <span className="d-none d-md-inline-block">Carregando...</span>
              </Button>
            )}
          </Select>
        </form>
        <br />
        <InclusaoCheckin
          isOpen={modal}
          toggle={this.toggleModal}
          contratante={data.contratante}
          contratado={data.contratado}
          disabled={1 === presencas.fetching}
          errors={presencas.errors}
          onOpened={() => {
            setTimeout(() => {
              actionsGuiaInterativo.abrirGuiaSeNecessario(
                Step.CADASTRO_CONTRATADO
              );
            }, 500);
          }}
          onChange={this.handleChange}
          onConfirm={this.handleConfirm}
        />
      </div>
    );
  }
}

let mapStateToProps = ({ registroAcesso, guiaInterativo }) => ({
  value: registroAcesso,
  guiaInterativo
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  actionsGuiaInterativo: bindActionCreators(actionsGuiaInterativo, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PresencaContratado);



// WEBPACK FOOTER //
// ./src/modules/registroAcesso/PresencaContratado.js